import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { discordLogin } from '../../store/reducers/Auth/authSlice';
import * as log from '../../utils/log';
const DiscordConfirmation = () => {
    const dispatch = useDispatch();
    const { search } = useLocation();
    const navigate = useNavigate();
    const params = new URLSearchParams(search);
    const code = params.get('code');
    const error = useSelector((state) => state.signup.error);
    useEffect(() => {
        log.error(error, code);
        if (!error && code) {
            dispatch(discordLogin(code));
        }
    }, [navigate, error, dispatch, code]);
    return _jsx(_Fragment, {});
};
export default DiscordConfirmation;
